export default "__VITE_ASSET__Ddqs_6vM__"